import React from 'react'
import { Footer } from '../../components/Footer'
import { Header } from '../../components/Header'
import HeadMeta from '../../components/HeadMeta'

const CompanyOfficePage = () => {
  return (
    <div>
      <HeadMeta title="事務所・店舗案内 | 企業情報 | 株式会社ベツダイ" description="マイホームはマイライフ。ベツダイがずっと大切にしているこの想いは、今までも、そしてこれからも変わることはありません。これからの時代と響き合う家づくりへ。私たちのチャレンジは続きます。" />
      <noscript>
        &lt;style&gt;body{'{'}visibility:visible{'}'}&lt;/style&gt;
      </noscript>
      <div className="c-page-sub__base">
        <div className="c-page-sub__header">
          <Header />
        </div>
        <div className="c-page-sub__breadcrumb">
          <div className="c-nav-breadcrumb">
            <ol>
              <li className="c-nav-breadcrumb__item"><a href="/">トップ</a>
            </li>
              <li className="c-nav-breadcrumb__item"><a href="/company/">企業情報</a>
            </li>
              <li className="c-nav-breadcrumb__item" data-breadcrumb="current">事務所・店舗案内</li>
            </ol>
          </div>
        </div>
        <div className="c-page-sub__main">
          <main>
            <article>
              <div className="c-page-sub__title-page">
                <div className="c-title-page" data-page="default">
                  <h1><span data-lang="en">OFFICE</span><span data-lang="ja">事務所・店舗案内</span></h1>
                </div>
              </div>
              <div className="c-page-sub__content-main">
                <div className="c-content-main">
                  <section data-type="section" data-mb="small" data-bgcolor="true">
                    <div className="concept-nav">
                      <ul>
                        <li>
                          <a href="/company/">企業コンセプト</a>
                        </li>
                        <li>
                          <a href="/company/about/">会社概要</a>
                        </li>
                        <li data-current="true">事務所・店舗案内</li>
                        <li>
                          <a href="/company/media/">CM・メディア掲載</a>
                        </li>
                      </ul>
                    </div>
                  </section>
                  <section data-type="section">
                    <h2>大分office</h2>
                    <div data-col={2} data-ratio="type01">
                      <div data-type="image"><img src="/img/pict-office-oita.jpg" alt="" /></div>
                      <div data-type="table">
                        <table className="col1-table" data-th-narrow>
                          <tbody>
                            <tr>
                              <th>所在地</th>
                              <td>〒870-0904 大分市向原東2丁目2-30<br />TEL&nbsp;<a href="tel:0975746330">097-574-6330</a>（代表）<br />FAX 097-551-6366 (代表) <br data-sponly />フリーダイヤル 0120-252-737</td>
                            </tr>
                            <tr>
                              <th>営業時間</th>
                              <td>9:00 ～ 18:00<br />毎週水曜日定休(盆・年末年始は休み)</td>
                            </tr>
                            <tr>
                              <th>事業内容</th>
                              <td>
                                <ul>
                                  <li className='parent'>新築戸建
                                    <ul>
                                      <li>
                                        <a href="https://betsudaihome.jp/" target="_blank">BETSUDAI HOME 大分</a>
                                        <a href="https://www.instagram.com/betsudaihome_official/" target="_blank">
                                          <img src="/img/icon-instagram.png" alt="Instagram" />
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li className='parent'>
                                    分譲マンション
                                    <ul>
                                      <li>
                                        <a href="https://betsudai.co.jp/service-greenhill/" target="_blank">GREEN HILLシリーズ</a>
                                        <a href="https://www.youtube.com/@betsudai.shinchiku/featured" target="_blank"><img src="/img/yt_logo_mono_light.png" alt="youtube" /></a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li className='parent'>
                                    不動産売買
                                    <ul>
                                      <li>

                                      <a href="https://fudosan.betsudai.jp/" target="_blank">ベツダイ不動産</a>
                                      </li>
                                      <li>

                                      <a href="https://portal.betsudai.jp/" target="_blank">ベツダイの不動産ポータル</a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li className='parent'>
                                    九重リゾート
                                    <ul>
                                      <li>

                                        <a href="https://stay-hossho.com/" target="_blank">スターダストヴィレッジ星生</a>
                                        <a href="https://www.instagram.com/stardustvillage_hossho/" target="_blank"><img src="/img/icon-instagram.png" alt="Instagram" /></a>

                                      </li>
                                      <li>
                                        <a href="https://hosshoclub.jp/" target="_blank">星生倶楽部</a>
                                      </li>
                                    </ul>

                                  </li>
                                  

                                  <li className='parent'>
                                    アフターサービス
                                    <ul>
                                      <li>
                                      <a href="https://betsudai.co.jp/plus/" target="_blank">BETSUDAI+</a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div data-type="map">
                      <div id="mapOita" />
                    </div>
                  </section>
                  {/* <section data-type="section">
                    <h2>東京office<br data-sponly />（BETSUDAI Inc. TOKYO）</h2>
                    <div data-col={2} data-ratio="type01">
                      <div data-type="image"><img src="/img/pict-office-tokyo.jpg" alt="" /></div>
                      <div data-type="table">
                        <table className="col1-table" data-th-narrow>
                          <tbody>
                            <tr>
                              <th>所在地</th>
                              <td>〒107-0062 東京都港区南青山4-13-9 クレセントヒルズ2F<br />TEL&nbsp;<a href="tel:0344007890">03-4400-7890</a><span data-pconly> </span><br data-sponly />FAX 03-4400-7891</td>
                            </tr>
                            <tr>
                              <th>営業時間</th>
                              <td>9:00 ～ 18:00<br />毎週日曜日定休(盆・年末年始は休み)</td>
                            </tr>
                            <tr>
                              <th>事業内容</th>
                              <td>
                                <ul>
                                  <li>
                                    <a href="https://biz.lifelabel.jp/" target="_blank">LIFE LABEL</a>
                                    <a href="https://www.instagram.com/lifelabel_official/" target="_blank"><img src="/img/icon-instagram.png" alt="Instagram" /></a>
                                    <a href="https://www.youtube.com/c/LIFELABEL/videos" target="_blank"><img src="/img/yt_logo_mono_light.png" alt="youtube" /></a>
                                    <a href="https://www.facebook.com/LifeLabelOfficial/"><img src="/img/icon-facebook.png" alt="facebook" /></a>
                                    <a href="https://www.pinterest.jp/lifelabel_official/" target="_blank"><img src="/img/icons8-pinterest-60.png" alt="pinterest" /></a>
                                    <a href="https://twitter.com/lmag_dolive" target="_blank"><img src="/img/x-logo-black.png" alt="x" /></a>
                                  </li>
                                  <li>
                                    <a href="https://partner.dolive.media/" target="_blank">Doliveメディアパートナー</a>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div data-type="map">
                      <div id="mapTokyo" />
                    </div>
                  </section> */}
                  <section data-type="section">
                    <h2>福岡office</h2>
                    <div data-col={2} data-ratio="type01">
                      <div data-type="image"><img src="/img/pict-office-fukuoka.jpg" alt="" /></div>
                      <div data-type="table">
                        <table className="col1-table" data-th-narrow>
                          <tbody>
                            <tr>
                              <th>所在地</th>
                              <td>〒818-0125 福岡県太宰府市五条2丁目5-25<br />TEL&nbsp;<a href="tel:0929181633">092-918-1633</a><span data-pconly> </span><br data-sponly />FAX 092-918-1622</td>
                            </tr>
                            <tr>
                              <th>営業時間</th>
                              <td>9:00 ～ 18:00<br />毎週水曜日定休(盆・年末年始は休み)</td>
                            </tr>
                            <tr>
                              <th>事業内容</th>
                              <td>
                                <ul>
                                  <li>
                                    <a href="https://fukuoka.betsudaihome.jp/" target="_blank">
                                    BETSUDAI HOME福岡
                                    </a>
                                    <a href="https://www.instagram.com/betsudaihome_fukuoka/" target="_blank">
                                      <img src="/img/icon-instagram.png" alt="Instagram" />
                                    </a>
                                    <a href="https://www.youtube.com/@%E3%83%99%E3%83%84%E3%83%80%E3%82%A4%E3%83%95%E3%82%AF%E3%82%AA%E3%82%AB" target="_blank"
                                    >
                                      <img src="/img/yt_logo_mono_light.png" alt="youtube" />
                                    </a>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div data-type="map">
                      <div id="mapFukuoka" />
                    </div>
                  </section>
                  <section data-type="section">
                    <h2>BETSUDAI DESIGN STUDIO</h2>
                    <div data-col={2} data-ratio="type01">
                      <div data-type="image"><img src="/img/pict-office-betsudai_rehome.jpg" alt="" /></div>
                      <div data-type="table">
                        <table className="col1-table" data-th-narrow>
                          <tbody>
                            <tr>
                              <th>所在地</th>
                              <td>〒870-0919 大分県大分市新栄町1−31<br />TEL&nbsp;<a href="tel:0975746337">097-574-6337</a><br data-sponly /><br />FAX 097-574-6447</td>
                            </tr>
                            <tr>
                              <th>営業時間</th>
                              <td>
                                <ul>
                                  <li className='parent'>9:00 ～ 18:00</li>
                                </ul>毎週水曜日定休(盆・年末年始は休み)
                              </td>
                            </tr>
                            <tr>
                              <th>事業内容</th>
                              <td>
                                <ul>
                                  <li className='parent'>
                                    <a href="https://designstudio.betsudai.jp/" target='_blank'>ベツダイデザインスタジオ</a>
                                    <a href="https://www.instagram.com/betsudai_designstudio/" target="_blank">
                                      <img src="/img/icon-instagram.png" alt="Instagram" />
                                    </a>
                                    <a href="https://www.youtube.com/@%E6%9A%AE%E3%82%89%E3%81%97%E3%81%AE%E6%95%99%E7%A7%91%E6%9B%B8" target="_blank"
                                    >
                                      <img src="/img/yt_logo_mono_light.png" alt="youtube" />
                                    </a>
                                  </li>
                                  <li className='parent'>
                                    リフォーム
                                    <ul>
                                      <li>

                                        <a href="https://betsudairehome.jp/" target="_blank">ベツダイリホーム</a>
                                        <a href="https://www.instagram.com/betsudai__rehome/" target="_blank"><img src="/img/icon-instagram.png" alt="Instagram" /></a>
                                        <a href="https://www.youtube.com/@%E3%83%AA%E3%83%95%E3%82%A9%E3%83%BC%E3%83%A0%E6%9A%AE%E3%82%89%E3%81%97%E3%81%AE%E6%95%99%E7%A7%91%E6%9B%B8" target="_blank"><img src="/img/yt_logo_mono_light.png" alt="youtube" /></a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div data-type="map">
                      <div id="mapBetsudaiRehome" />
                    </div>
                  </section>
                  <section data-type="section">
                    <h2>長浜office</h2>
                    <div data-col={2} data-ratio="type01">
                      <div data-type="image"><img src="/img/nagahama.jpg" alt="" /></div>
                      <div data-type="table">
                        <table className="col1-table" data-th-narrow>
                          <tbody>
                            <tr>
                              <th>所在地</th>
                              <td>〒870-0023 大分市長浜町3丁目16-3<br />TEL&nbsp;<a href="tel:0975336000">097-533-6000</a><span data-pconly> </span><br data-sponly />FAX 097-533-6848</td>
                            </tr>
                            <tr>
                              <th>営業時間</th>
                              <td>9:00 ～ 18:00</td>
                            </tr>
                            <tr>
                              <th>事業内容</th>
                              <td>
                                <ul>
                                  <li>
                                    <a href="https://rent.betsudai.jp/" target="_blank">ベツダイ賃貸不動産</a>
                                    <a href="https://www.instagram.com/betsudai_chintai/" target="_blank"><img src="/img/icon-instagram.png" alt="Instagram" /></a>
                                  </li>
                                  <li>
                                    <a href="https://ap.betsudai.jp/" target="_blank">ベツダイ資産活用</a>
                                  </li>
                                  <li>
                                    <a href="https://ap.betsudai.jp/rental/" target="_blank">ベツダイ不動産管理</a>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div data-type="map">
                      <div id="mapLifePartnerNagahama" />
                    </div>
                  </section>
                  <section data-type="section">
                    <h2>東大分office</h2>
                    <div data-col={2} data-ratio="type01">
                      <div data-type="image"><img src="/img/higashi.jpg" alt="" /></div>
                      <div data-type="table">
                        <table className="col1-table" data-th-narrow>
                          <tbody>
                            <tr>
                              <th>所在地</th>
                              <td>〒870-0134 大分県大分市猪野723番1<br />TEL&nbsp;<a href="tel:0975746390">097-574-6390</a><span data-pconly> </span><br data-sponly />FAX 097-574-6391</td>
                            </tr>
                            <tr>
                              <th>営業時間</th>
                              <td>9:00 ～ 18:00</td>
                            </tr>
                            <tr>
                              <th>事業内容</th>
                              <td>
                                <ul>
                                  <li>
                                    <a href="https://rent.betsudai.jp/" target="_blank">ベツダイ賃貸不動産</a>
                                    <a href="https://www.instagram.com/betsudai_chintai/" target="_blank"><img src="/img/icon-instagram.png" alt="Instagram" /></a>
                                  </li>
                                  <li>
                                    <a href="https://ap.betsudai.jp/" target="_blank">ベツダイ資産活用</a>
                                  </li>
                                  <li>
                                    <a href="https://ap.betsudai.jp/rental/" target="_blank">ベツダイ不動産管理</a>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div data-type="map">
                      <div id="mapLifePartnerHigashi" />
                    </div>
                  </section>
                  <section data-type="section">
                    <h2>マンション分譲管理</h2>
                    <div data-col={2} data-ratio="type01">
                      <div data-type="image"><img src="/img/bunjo.jpg" alt="" /></div>
                      <div data-type="table">
                        <table className="col1-table" data-th-narrow>
                          <tbody>
                            <tr>
                              <th>所在地</th>
                              <td>〒870-0907 大分県大分市大津町1丁目14-2 リルームス大津町102<br />TEL&nbsp;<a href="tel:0975746390">097-533-2471(代表番号)</a><span data-pconly> </span><br data-sponly />FAX 097-574-6341</td>
                            </tr>
                            <tr>
                              <th>営業時間</th>
                              <td>9:00 ～ 18:00</td>
                            </tr>
                            <tr>
                              <th>事業内容</th>
                              <td>
                                <ul>
                                  <li>
                                    <a href="https://mansion-mgmt.betsudai.jp/" target="_blank">ベツダイのマンション管理</a>
                                  </li>
                                  {/* <li>
                                  <a href="https://rent.betsudai.jp/" target="_blank">ベツダイ賃貸不動産</a>
                                </li>
                                  <li>
                                  <a href="https://ap.betsudai.jp/" target="_blank">ベツダイ資産活用</a>
                                </li>
                                  <li>
                                  <a href="https://ap.betsudai.jp/rental/" target="_blank">ベツダイ不動産管理</a>
                                </li> */}
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div data-type="map">
                      <div id="mapBunjo" />
                    </div>
                  </section>
                </div>
              </div>
            </article>
          </main>
        </div>
        <div className="c-page-sub__footer">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default CompanyOfficePage